import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'

const getMessage = (field) => 'The ' + field + ' cannot later than system date.'

const validate = (value) => {
  if (value) {
    return !isAfter(removeTime(value), removeTime(new Date()))
  } else {
    return true
  }
}

export default {
  getMessage,
  validate
}
